import { render, staticRenderFns } from "./OrderCheckoutCompanyRegistrationRenewal.vue?vue&type=template&id=1b9aa25c"
import script from "./OrderCheckoutCompanyRegistrationRenewal.vue?vue&type=script&lang=js"
export * from "./OrderCheckoutCompanyRegistrationRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports